import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import './index.scss';

import InfoCharcoalIcon from '../../../assets/images/info-charcoal.svg';
import {
  getAllAddons,
  getAllAddonsLoader
} from '../../burger-king-lib/redux/productListing/actions';
import Button from '../../components/button';
import CountButton from '../../components/lat-count-button';
import Loader from '../../components/loader-spin';
import CardMeal from '../../components/new-card';
import Modal from '../../containers/modal';
import {
  getAddonsPayload,
  getAddonsPayloadOld
} from '../../payload-handling/cart';
import { getLeftArrowImage } from '../../utils/imageChanges';
import { deliveryAddressStorage, getCategoryImage } from '../../utils/services';
import LocationRestriction from '../../components/location-restriction-popover';
import StepProgress from '../../components/step-progress';
import MultiSelectComponent from '../../components/multi-select-component';
import { trackEvent } from '../../../analytics_wrapper';
import { add_to_cart } from '../../../analyics_constants';
import { SessionStorage } from '../../burger-king-lib/utils/storage.web';
import { LocalSessionKey } from '../../burger-king-lib/constants/app-constants';

const CustomiseScreen = props => {
  const history = useHistory();
  const theme = window?.sessionStorage?.getItem('theme');
  const OUTLET_ID = window?.sessionStorage?.getItem('OUTLET_ID');
  const dispatch = useDispatch();
  const [select, setSelect] = useState(100);
  const [wholeData, setWholeData] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState({});
  const [showNutritionModal, setShowNutritionModal] = useState(false);

  const [currentStep, setCurrentStep] = useState(0);
  const orderProcess = ['Customise', 'Choose Side', 'Choose Drink'];

  const hasSequence0or1 = wholeData.some(
    product => product.sequence === 0 || product.sequence === 1
  );
  const hasSequence2 = wholeData.some(product => product.sequence === 2);
  const hasSequence3 = wholeData.some(product => product.sequence === 3);
  const isSplitUi = hasSequence0or1 && hasSequence2 && hasSequence3;

  const handleNextStep = () => {
    if (currentStep < orderProcess.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePreviousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const buttonConfig = {
    label: currentStep < orderProcess.length - 1 ? 'Continue' : 'Add to Cart',
    onClick:
      currentStep < orderProcess.length - 1
        ? handleNextStep
        : () => onAddToCartClick()
  };

  function resetAll() {
    setWholeData([]);
    setSelect(100);
    setSelectedProducts({});
  }

  function onHandleCheckboxChange(itemIndex, parentIndex) {
    const newArray = [...wholeData];
    const item = newArray[parentIndex];
    if (item && item.products) {
      const product = item.products[itemIndex];
      if (product && typeof product.quantity === 'number') {
        product.quantity = product.quantity === 0 ? 1 : 0;
      }
    }
    return newArray;
  }

  function onHandleCheckboxChange1(itemIndex, parentIndex) {
    const newArray = [...wholeData];
    const item = newArray[parentIndex];

    if (item && item.products) {
      const products = item.products;
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        if (product && typeof product.quantity === 'number') {
          if (i === itemIndex) {
            // Toggle the selection state
            product.quantity = product.quantity === 1 ? 0 : 1;
          } else {
            // Unselect other products
            product.quantity = 0;
          }
        }
      }
    }
    return newArray;
  }

  function handleCheckboxChange(checkboxId, item, itemIndex, parentIndex) {
    let arr = onHandleCheckboxChange(itemIndex, parentIndex);
    setWholeData(arr);
  }

  const radioClick = (checkboxId, item, itemIndex, parentIndex) => {
    let arr = onHandleCheckboxChange1(itemIndex, parentIndex);
    setWholeData(arr);
  };
  // const getAddonsList = () => {
  //   let payload;
  //   if (
  //     props?.payloadForNextApi?.isFrom === 'new' &&
  //     Object.values(props?.payloadForNextApi).length === 3
  //   ) {
  //     payload = getAddonsPayloadOld(props?.payloadForNextApi?.entity_id);
  //   } else if (
  //     props?.isCustomise === 'addnew' &&
  //     props.payloadForNextApi?.variants_quantity === 1
  //   ) {
  //     payload = getAddonsPayloadOld(props?.payloadForNextApi?.entity_id);
  //   } else if (
  //     props?.isCustomise === 'customise' &&
  //     props.content.addons_quantity === 0 &&
  //     props.content.variants_quantity === 1 &&
  //     Object.values(props?.payloadForNextApi).length !== 3
  //   ) {
  //     payload = getAddonsPayload(
  //       props?.payloadForNextApi?.variant_category?.[0]?.variants?.[0]
  //         ?.entity_id ?? props?.payloadForNextApi?.entity_id,
  //       props?.payloadForNextApi?.product_id,
  //       props?.payloadForNextApi?.name
  //     );
  //   } else {
  //     let latId =
  //       props?.isCustomise !== 'customise'
  //         ? props?.content?.product_id || props?.content?.id
  //         : props?.payloadForNextApi?.product_id;
  //     const latId12 = props?.content?.id ?? props?.content?.product_id;
  //     latId = latId?.includes('-')
  //       ? latId12
  //       : props?.content?.product_id ||
  //         props?.payloadForNextApi?.product_id ||
  //         props?.content?.id;
  //     payload = getAddonsPayload(
  //       props?.payloadForNextApi?.variant_category?.[0]?.variants?.[0]
  //         ?.entity_id ?? props?.payloadForNextApi?.entity_id,
  //       latId,
  //       props?.payloadForNextApi?.name
  //     );

  //     if (props.isFrom === 'cart') {
  //       payload = getAddonsPayload(
  //         props?.payloadForNextApi?.category_id ??
  //           props?.payloadForNextApi?.entity_id,
  //         props?.content.product_id ?? props?.payloadForNextApi?.product_id,
  //         props?.payloadForNextApi?.variant_name ??
  //           props?.payloadForNextApi?.name
  //       );
  //     }

  //     if (
  //       !props?.payloadForNextApi?.isItCombosFlow &&
  //       !payload?.variant_id?.includes('V')
  //     ) {
  //       payload = getAddonsPayloadOld(props?.payloadForNextApi?.entity_id);
  //     }
  //   }
  //   payload.product_id =
  //     props?.isCustomise === 'customise' && props?.isFrom === 'cart'
  //       ? props?.payloadForNextApi?.product_id
  //       : payload.product_id;

  //   if (props?.location?.state?.extra?.isFromDeeplink) {
  //     payload.product_id =
  //       props?.location?.state?.extra?.product_id ||
  //       props?.payloadForNextApi?.product_id;
  //     payload.name = props?.location?.state?.extra?.name
  //       ? props?.location?.state?.extra?.name
  //       : '';
  //   }
  //   dispatch(getAllAddons(payload, props.isFrom, props?.isCustomise));
  // };
  const getAddonsList = () => {
    let payload;
    if (props.content.addons_quantity === 0) {
      payload = getAddonsPayloadOld(props?.payloadForNextApi?.entity_id);
    } else {
      const productId =
        props.content.variants_quantity > 1
          ? props?.content.product_id ||
            props.payloadForNextApi.product_id ||
            props?.content.id
          : props?.content.product_id
          ? props?.content.product_id
          : props.payloadForNextApi.product_id || props?.content.id;

      const variant_id =
        props?.location?.state?.extra?.type === 'checkout'
          ? props?.content?.category_id
          : props.isFrom === 'search'
          ? props.content.variants_quantity > 1
            ? props?.payloadForNextApi?.entity_id
            : props?.content.variant?.v_entity_id
          : props.payloadForNextApi?.type === 'banner'
          ? props?.content?.variant_category?.[0]?.variants?.[0]?.entity_id
          : props?.payloadForNextApi.entity_id ??
            props?.content?.variant_category?.[0]?.variants?.[0]?.entity_id ??
            props?.content.variant?.v_entity_id;
      payload = getAddonsPayload(
        variant_id,
        productId,
        props?.payloadForNextApi?.variant_name ?? props?.payloadForNextApi?.name
      );
    }
    dispatch(getAllAddons(payload, props.isFrom, props?.isCustomise));
  };

  useEffect(() => {
    getAddonsList();
    getTotalPrice([]);
    return () => {
      resetAll();
    };
  }, []);

  function updateQuantity(parentId, productId, data) {
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      if (item.id === parentId) {
        item.products.forEach(product => {
          product.quantity = 0;
        });

        for (let j = 0; j < item.products.length; j++) {
          const product = item.products[j];
          if (product.id === productId || product.entity_id === productId) {
            product.quantity = 1;
            return data;
          }
        }
      }
    }
    return data;
  }

  const handleSelectProduct = (sectionId, productId) => {
    let updatedArray = updateQuantity(sectionId, productId, wholeData);
    updatedArray = [...updatedArray];
    setWholeData(updatedArray);
  };

  const response = useSelector(state => state);
  const loader = response?.productListing?.isLoading;
  const finalAddons = response?.productListing?.getAllAddons?.content?.result;

  const fun = (props, finalAddons) => {
    let updatedFirstArray;
    if (props) {
      updatedFirstArray = finalAddons.map((card, index) => {
        if (card.card_type === 'Horizontal') {
          return {
            ...card,
            products: card.products.map(product => {
              const matchingItem = Object.values(props).find(
                item =>
                  item.entity_id === product.entity_id &&
                  item.product_name === product.name
              );
              if (!!matchingItem) {
                return {
                  ...product,
                  quantity: matchingItem.quantity
                };
              }
              return product;
            })
          };
        } else {
          return {
            ...card,
            products: card.products.map(product => {
              const matchingItem = Object.values(props).find(
                item =>
                  item.entity_id === product.entity_id &&
                  item.product_name === product.name
              );
              if (!!matchingItem) {
                return {
                  ...product,
                  quantity: matchingItem.quantity
                };
              }
              return product;
            })
          };
        }
      });
    } else {
      updatedFirstArray = finalAddons;
    }
    return updatedFirstArray;
  };

  useEffect(() => {
    if (finalAddons && finalAddons.length > 0) {
      let updatedFirstArray;
      let addons = props?.payloadForNextApi?.addons ?? props?.content?.addons;
      if (addons && props?.isCustomise === 'customise') {
        updatedFirstArray = fun(addons, finalAddons);
      } else {
        updatedFirstArray = fun(null, finalAddons);
      }
      setWholeData(updatedFirstArray);
    } else {
      setWholeData([]);
    }
  }, [finalAddons]);

  if (response?.productListing?.getAllAddons?.error === 1) {
    alert(response?.productListing?.getAllAddons?.message);
  }

  function increaseQuantity(parentIndex, index) {
    // Make a shallow copy of the input array
    const newArray = [...wholeData];

    // Find the element at parentIndex in the array
    const parentElement = newArray[parentIndex];

    // Check if the parentIndex is valid and the element has a "products" array
    if (parentElement && parentElement.products) {
      // Find the product at the specified index in the "products" array
      const product = parentElement.products[index];

      // Check if the product exists and has a "quantity" field
      if (product && typeof product.quantity === 'number') {
        // Increase the quantity by one
        product.quantity += 1;
      }
    }

    return newArray;
  }

  const handleAddClick = (tt, indx, parentIndex) => {
    let latArr = increaseQuantity(parentIndex, indx);
    latArr = [...latArr];
    setWholeData(latArr);
  };

  function handleQuantityChange1(itemIndex, isIncrement, pIndex, entire) {
    const newArray = [...wholeData];
    const item = newArray[pIndex];

    // Check if the item has a "products" array
    if (item && item.products) {
      // Find the specified product within the "products" array
      const product = item.products[itemIndex];

      // Check if the product exists and has a "quantity" field
      if (product && typeof product.quantity === 'number') {
        if (product?.quantity === entire?.max && isIncrement) {
          alert('Maximum limit reached');
          return;
        }
        // Increment or decrement the quantity based on the isIncrement flag
        if (isIncrement) {
          product.quantity += 1;
        } else {
          // Ensure quantity does not go below 0
          product.quantity = Math.max(0, product.quantity - 1);
        }
      }
    }
    setWholeData(newArray);
  }

  const renderDom = (data, parentIndex, totalData) => (
    <>
      {data?.products?.map((item, index) => {
        const imageUrl = getCategoryImage(item.image_urls, 'pdpe');

        return (
          <div className={`row-div`}>
            <div className="flex-row">
              <div>
                <picture>
                  <source
                    srcSet={`${imageUrl['1x']}, ${imageUrl['2x']} 2x, ${imageUrl['3x']} 3x`}
                    type="image/jpeg/png"
                  />
                  <img
                    src={
                      imageUrl['2x']
                        ? `${imageUrl['2x']}`
                        : process.env.REACT_APP_API_IMAGE_URL +
                          '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg'
                    }
                    alt={item.name}
                    className="card-meal__img"
                    style={{
                      width: '10rem'
                    }}
                  />
                </picture>
              </div>
              <div className="flex-col">
                <p className="row-text">{item.name}</p>
                <p className="row-text">
                  {'Rs' + ' ' + item?.variants?.price + ' /-'}
                </p>
              </div>
            </div>
            <div className="card-gen__addtocart">
              {renderRadioOrButton(data, item, index, totalData, parentIndex)}
            </div>
          </div>
        );
      })}
    </>
  );

  const renderRadioOrButton = (data, item, index, totalData, parentIndex) => {
    if (data?.button_type === 'is_radio') {
      return (
        <div
          className="radio-button"
          role="presentation"
          onClick={() => radioClick(item?.id, item, index, parentIndex)}
        >
          <div
            role="presentation"
            className={`card-meal__radio ${
              item?.quantity ? `card-meal__radio_active delivery` : ''
            }`}
          />
        </div>
      );
    } else if (data?.button_type === 'is_add_icon') {
      if (data?.is_allocated && item.quantity) {
        return (
          <CountButton
            theme="delivery"
            {...props}
            index={index}
            pIndex={parentIndex}
            handleIncrement={() =>
              handleQuantityChange1(index, true, parentIndex, data)
            }
            handleDecrement={() =>
              handleQuantityChange1(index, false, parentIndex, data)
            }
            entireData={[item]}
            content={item?.quantity}
            quantity={item?.quantity}
          />
        );
      } else {
        return (
          <Button
            content={'Add'}
            theme={'delivery'}
            size={'is-small'}
            onClick={() => handleAddClick(data, index, parentIndex, totalData)}
          />
        );
      }
    } else if (data?.button_type === 'is_check') {
      return (
        <label className="charity__label d-block">
          <input
            type="checkbox"
            className="charity__checkbox"
            name={item.name}
            id={item.id}
            checked={item.quantity > 0}
            onChange={() =>
              handleCheckboxChange(item.id, item, index, parentIndex)
            }
          />
          <span
            className={`charity__custom delivery ${
              false ? '' : 'charity__custom_uncheck'
            } updated-border`}
          />
        </label>
      );
    } else {
      return (
        <div
          className="radio-button"
          role="presentation"
          onClick={() => radioClick(item?.id, item, index, parentIndex)}
        >
          <div
            role="presentation"
            className={`card-meal__radio ${
              item?.quantity ? `card-meal__radio_active delivery` : ''
            }`}
          />
        </div>
      );
    }
  };

  const renderDom2 = (data, pIndex) => (
    <>
      {data?.products?.map((item, index) => (
        <CardMeal
          theme={theme}
          {...item}
          index={index}
          extraClass="text-one"
          idx={props.index}
          select={select}
          type="addons"
          sectionId={data.id}
          onSelectProduct={handleSelectProduct}
          selectedProduct={selectedProducts[data.id]}
          entireData={data.products}
          entire={data}
          setStat={pIndex}
          item={item}
          pIndex={pIndex}
          handleIncrement={handleQuantityChange1} // increment quantity click
          handleDecrement={handleQuantityChange1} // Decrement quantity click
          handleOnClick={handleAddClick} // add button click
          handleCheckboxChange={handleCheckboxChange} // checkbox click
          handleRadioBtnChange={radioClick} // radio button click
        />
      ))}
    </>
  );

  const renderDom3 = (data, pIndex) => (
    <>
      {data?.products?.map((item, index) => (
        <MultiSelectComponent
          key={item.id}
          index={index}
          {...item}
          item={item}
          data={data}
          pIndex={pIndex}
          onSelectProduct={handleCheckboxChange}
        />
      ))}
    </>
  );

  const imageUrl = getCategoryImage(
    response?.productListing?.getAllAddons?.content?.flex_data?.image_urls ||
      props?.content?.image_urls,
    response?.productListing?.getAllAddons?.content?.flex_data?.image_urls
      ? 'pdpe'
      : 'plp'
  );

  const getTotalPrice = () => {
    let productPrice =
      response?.productListing?.getAllAddons?.content?.flex_data?.price ??
      props?.content?.variant_category?.[0]?.variants?.[0]?.price;
    let productVariantPrice = 0;
    if (wholeData) {
      wholeData.length > 0 &&
        wholeData.map(item => {
          item.products.map(pItem => {
            if (!pItem?.is_hide && pItem?.quantity > 0) {
              const totalPrice = pItem.variants.price * pItem?.quantity;
              productVariantPrice += totalPrice;
            }
          });
        });
    }
    productPrice += productVariantPrice;
    return isNaN(productPrice) ? 0 : Math.round(productPrice);
  };

  const getActualTotalPrice = () => {
    const content = response?.productListing?.getAllAddons?.content;
    const flexData = content?.flex_data;

    let productPrice = flexData?.actual_price || 0;
    let productVariantPrice = 0;

    if (wholeData) {
      wholeData.length > 0 &&
        wholeData.map(item => {
          item.products.map(pItem => {
            if (
              pItem?.quantity > 0 &&
              !pItem?.is_hide &&
              pItem.variants &&
              pItem.variants.price
            ) {
              productVariantPrice += pItem.variants.price * pItem.quantity;
            }
          });
        });
    }

    productPrice += productVariantPrice;
    return productPrice.toFixed();
  };

  const handleNutritionMoreInfo = () => {
    setShowNutritionModal(true);
  };

  const onAddToCartClick = () => {
    dispatch(getAllAddonsLoader());
    const flexData = response?.productListing?.getAllAddons?.content?.flex_data;
    let newCartPayload = {};
    const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
    const deliveryAddress = deliveryAddressStorage.get();

    if (props.content && Object.keys(props.content).length > 4) {
      Object.assign(newCartPayload, props.content);
    } else {
      Object.assign(newCartPayload, flexData);
    }
    newCartPayload = {
      ...newCartPayload,
      ...flexData,
      name: flexData?.product_name,
      variant_name: flexData?.name
    };

    // newCartPayload.category_id =
    //   props?.payloadForNextApi?.entity_id ??
    //   props?.payloadForNextApi?.category_id;
    newCartPayload.variant_name = props?.payloadForNextApi?.variant_name;
    newCartPayload.product_id = props.payloadForNextApi.id;

    if (newCartPayload.entity_id === newCartPayload.category_id) {
      newCartPayload.category_id =
        newCartPayload?.variant_category?.[0]?.variants?.[0]?.entity_id;
    }

    const tempAddons = [];
    const tempAlakartAddons = [];
    let isAddonAdded = false;

    wholeData.forEach(element => {
      const productBasedProducts = element?.products?.filter(
        item => item?.quantity > 0 && element?.is_product_based
      );

      if (productBasedProducts.length > 0) {
        productBasedProducts.forEach(product => {
          tempAddons.push({
            category_name: element?.display_name,
            category_entity_id: element?.entity_id,
            id: product?.id,
            entity_id: product?.entity_id,
            quantity: product?.quantity,
            name: product?.name,
            price: product?.variants?.price,
            img_url: product?.image_urls[0]
              ? product?.image_urls[0]?.images[1]?.image['3x']
              : '',
            max: product?.max,
            min: product?.min
          });
        });
      }

      const alakartProducts = element?.products?.filter(
        item => item?.quantity > 0 && !element.is_product_based
      );

      if (alakartProducts.length > 0) {
        alakartProducts.forEach(product => {
          tempAlakartAddons.push({
            outlet_id: OUTLET_ID,
            id: product?.id,
            name: product?.name,
            cart_added_for: theme === 'takeaway' ? 'dinein' : theme,
            quantity: product?.quantity,
            entity_id: product?.entity_id,
            price: product?.variants?.price,
            tax: '',
            is_adding: true,
            is_repeat: false,
            is_combo: false,
            is_customise: false,
            customise_name: '',
            customise_id: '',
            addons: [],
            is_addon: !!product?.is_addon,
            img_url: '',
            max: product?.max
          });
        });
      }
    });

    if (tempAddons.length > 0) {
      isAddonAdded = true;
    } else {
      isAddonAdded = false;
    }

    const quantity = props?.payloadForNextApi?.quantity;
    let finalQuantity = null;

    if (props.isFrom === 'cart' || props.isCustomise === 'customise') {
      finalQuantity = quantity ? quantity : newCartPayload.quantity;
    }

    if (props?.isCustomise === 'customise' && props?.isFrom === 'cart') {
      newCartPayload.addons_quantity =
        props?.payloadForNextApi?.addons_quantity ??
        props?.content?.addons_quantity;
      newCartPayload.variants_quantity =
        props?.payloadForNextApi?.variants_quantity ??
        props?.content?.variants_quantity;
    }
    props.addToCartPayload(
      true,
      newCartPayload,
      false,
      tempAddons,
      props?.isCustomise === 'customise' ? 'customise' : 'normal',
      finalQuantity,
      null,
      tempAlakartAddons,
      props
    );
    trackEvent(add_to_cart, {
      order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
      city: addressInfo?.city ? addressInfo?.city : '',
      state: deliveryAddress?.state ? deliveryAddress?.state : '',
      store_id: addressInfo?.outlet_id,
      product_name: flexData?.product_name,
      product_price: parseFloat(flexData?.price),
      product_quantity: '',
      crown_points: window.localStorage.getItem('crowns')
        ? window.localStorage.getItem('crowns')
        : 0,
      store_name: addressInfo?.outlet_name,
      category_id: flexData?.category_id,
      category_name: newCartPayload?.category_name
    });
  };

  const isFirstItemData = response?.productListing?.getAllAddons?.content?.flex_data?.nutritional_data?.some(
    item => !item?.isFirstItem
  );

  const renderNutritionInfo = item => {
    if (item?.isFirstItem) {
      return (
        <div>
          {item?.nutritionName} - {item?.nutritionValue} {item?.nutritionUnit}{' '}
          {isFirstItemData && '| Nutrition Info'}
        </div>
      );
    }
  };

  const handleCloseModal = () => {
    setShowNutritionModal(false);
  };

  const NutritionModalUI = () => {
    return (
      <Modal modalCustomClass="nutrition-modal-view" hideClose>
        <div className="modal-content">
          <img
            onClick={handleCloseModal}
            src={getLeftArrowImage()}
            alt="back button"
          />
          <div className="nutrition-title">
            {
              response?.productListing?.getAllAddons?.content?.flex_data
                ?.product_name
            }
          </div>
        </div>
        <div className="nutrion-view">
          {response?.productListing?.getAllAddons?.content?.flex_data?.nutritional_data
            ?.filter(item => item?.nutritionName?.toLowerCase() !== 'allergens')
            ?.map(
              item =>
                !item?.isFirstItem && (
                  <div className="nutrition-card">
                    <div className="nutrition-name">{item?.nutritionName}</div>
                    <div className="nutrition-value">
                      {item?.nutritionValue} {item?.nutritionUnit}
                    </div>
                  </div>
                )
            )}
          {response?.productListing?.getAllAddons?.content?.flex_data?.nutritional_data?.filter(
            item => item?.nutritionName?.toLowerCase() === 'allergens'
          )?.length ? (
            <div className="nutrition-title">Allergens</div>
          ) : (
            ''
          )}
          {response?.productListing?.getAllAddons?.content?.flex_data?.nutritional_data
            ?.filter(item => item?.nutritionName?.toLowerCase() === 'allergens')
            ?.map(item => (
              <div className="nutrition-card">
                <div className="nutrition-name">{item?.nutritionValue}</div>
                <div className="nutrition-value">{item?.nutritionUnit}</div>
              </div>
            ))}
        </div>
      </Modal>
    );
  };
  const { variant_name = '' } = props?.payloadForNextApi || {};
  return (
    <div className="custom-model-container">
      {showNutritionModal && <NutritionModalUI />}
      {!finalAddons?.length &&
        !response?.productListing?.getAllAddons?.content?.flex_data &&
        !loader && (
          <LocationRestriction
            title={'SORRY'}
            description={'Product is not available at this store.'}
            okayClick={() => history.replace('/')}
          />
        )}
      {(finalAddons?.length &&
        response?.productListing?.getAllAddons?.content?.flex_data &&
        loader === undefined) ||
      loader ? (
        <Loader fitContent="full" theme={theme} />
      ) : (
        <div className="white-area">
          <div className="login-pg_close">
            <img
              src={getLeftArrowImage(theme)}
              width="18"
              height="18"
              style={{
                cursor: 'pointer'
              }}
              onClick={() => {
                if (currentStep > 0) {
                  handlePreviousStep();
                } else {
                  resetAll();
                  props.otherPopUpHide(true, props.isFrom);
                }
              }}
            />
          </div>
          <div className="image-div">
            <picture>
              <source
                srcSet={`${imageUrl['1x']} 1x, ${imageUrl['2x']} 2x, ${imageUrl['3x']} 3x`}
                type="image/jpeg/png"
              />
              <img
                src={
                  imageUrl['3x']
                    ? `${imageUrl['3x']}`
                    : process.env.REACT_APP_API_IMAGE_URL +
                      '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg'
                }
                className="card-meal__img"
                style={{
                  width: '36rem'
                }}
              />
            </picture>
          </div>
          <div className="title-style">
            <center style={{ textTransform: 'uppercase' }}>
              {response?.productListing?.getAllAddons?.content?.flex_data
                ?.product_name ?? 'No Data Found'}{' '}
              <span
                className="position-center"
                style={{
                  fontSize: '1.5rem'
                }}
              >
                {`${!!variant_name ? `(${variant_name})` : ''}`}
              </span>
            </center>
            <div
              className="position-center"
              style={{
                fontSize: '1.5rem',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                cursor: 'pointer'
              }}
              onClick={isFirstItemData && handleNutritionMoreInfo}
            >
              {response?.productListing?.getAllAddons?.content?.flex_data?.nutritional_data?.map(
                item => renderNutritionInfo(item)
              )}
              {response?.productListing?.getAllAddons?.content?.flex_data
                ?.nutritional_data &&
                isFirstItemData && (
                  <div style={{ display: 'flex', marginLeft: '0.5rem' }}>
                    <img src={InfoCharcoalIcon} alt="InfoCharcoalIcon" />
                  </div>
                )}
            </div>
          </div>
          {isSplitUi && (
            <StepProgress
              steps={orderProcess}
              currentStep={currentStep}
              onChangeStep={setCurrentStep}
            />
          )}
          {wholeData?.length > 0 &&
            (isSplitUi
              ? wholeData
                  .map((item, index) => ({
                    ...item,
                    originalIndex: index
                  }))
                  .map(item => {
                    const isCurrentStep =
                      (currentStep === 0 &&
                        (item.sequence === 0 || item.sequence === 1)) ||
                      (currentStep === 1 && item.sequence === 2) ||
                      (currentStep === 2 && item.sequence === 3);

                    return isCurrentStep && !item.is_hide ? (
                      <React.Fragment key={item.originalIndex.toString()}>
                        <p className="title-style-one">{item.display_name}</p>
                        {item.card_type === 'Horizontal' ? (
                          <div>
                            {renderDom(item, item.originalIndex, wholeData)}
                          </div>
                        ) : item.card_type === 'MultiSelect' ? (
                          <div className="flex-data1">
                            {renderDom3(item, item.originalIndex)}
                          </div>
                        ) : (
                          <div className="flex-data1">
                            {renderDom2(item, item.originalIndex)}
                          </div>
                        )}
                      </React.Fragment>
                    ) : null;
                  })
              : wholeData
                  .map((item, index) => ({
                    ...item,
                    originalIndex: index
                  }))
                  .map(item =>
                    !item.is_hide ? (
                      <React.Fragment key={item.originalIndex.toString()}>
                        <p className="title-style-one">{item.display_name}</p>
                        {item.card_type === 'Horizontal' ? (
                          <div>
                            {renderDom(item, item.originalIndex, wholeData)}
                          </div>
                        ) : item.card_type === 'MultiSelect' ? (
                          <div className="flex-data1">
                            {renderDom3(item, item.originalIndex)}
                          </div>
                        ) : (
                          <div className="flex-data1">
                            {renderDom2(item, item.originalIndex)}
                          </div>
                        )}
                      </React.Fragment>
                    ) : null
                  ))}

          <div className="cardBlock white-bg">
            <div className="custom__btn">
              <p className="price__text">
                <span>₹ {getTotalPrice()} /-</span>&nbsp;
                {response?.productListing?.getAllAddons?.content?.flex_data
                  ?.actual_price ? (
                  <span
                    className="extra-style"
                    style={{
                      fontSize: '2rem'
                    }}
                  >
                    {getActualTotalPrice()}
                  </span>
                ) : null}
              </p>
              <p className="price__discription">Price Before Tax</p>
            </div>
            {isSplitUi ? (
              <Button
                size={'is-medium'}
                onClick={buttonConfig.onClick}
                className={'custom__btn custom-width'}
                content={buttonConfig.label}
              />
            ) : (
              <Button
                size={'is-medium'}
                onClick={onAddToCartClick}
                className={'custom__btn custom-width'}
                content={'Add to cart'}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomiseScreen;
